export const getHasErrorsByFields = ({ errors = {}, fields = [] } = {}) => {
    if (!errors || !fields?.length) return false;

    return fields.some((field) => errors[field]);
};
